
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">
           
            <payMethod-edit-win *ngSwitchCase="true"></payMethod-edit-win>
            <payMethod-details *ngSwitchCase="false"></payMethod-details>
        </div>
    </ng-template>  
</main-form-modal>